/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Meta_DescriptionInputs */

const en_password_reset_meta_description = /** @type {(inputs: Password_Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quickly and securely reset your password on Listening. Follow the simple steps to regain access to your account.`)
};

const es_password_reset_meta_description = /** @type {(inputs: Password_Reset_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablece tu contraseña en Listening de forma rápida y segura. Sigue los sencillos pasos para recuperar el acceso a tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Quickly and securely reset your password on Listening. Follow the simple steps to regain access to your account." |
*
* @param {Password_Reset_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_meta_description = /** @type {((inputs?: Password_Reset_Meta_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Meta_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_meta_description(inputs)
	return en_password_reset_meta_description(inputs)
});